import * as tslib_1 from "tslib";
import { CredentialStoreResourceType, } from '@models';
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { CredentialStoresService, } from '@services';
import * as i0 from "@angular/core";
import * as i1 from "../../../services/credential-stores.service";
var RobotCredentialStoreResourcesSource = /** @class */ (function () {
    function RobotCredentialStoreResourcesSource(_credentialStore) {
        this._credentialStore = _credentialStore;
    }
    Object.defineProperty(RobotCredentialStoreResourcesSource.prototype, "mapper", {
        get: function () {
            return this._credentialStore.mapper;
        },
        enumerable: true,
        configurable: true
    });
    RobotCredentialStoreResourcesSource.prototype.get = function (qo) {
        return this._credentialStore.getResourcesForCredentialStore(this.credentialStore, CredentialStoreResourceType.RobotCredential, qo);
    };
    RobotCredentialStoreResourcesSource.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RobotCredentialStoreResourcesSource_Factory() { return new RobotCredentialStoreResourcesSource(i0.ɵɵinject(i1.CredentialStoresService)); }, token: RobotCredentialStoreResourcesSource, providedIn: "root" });
    return RobotCredentialStoreResourcesSource;
}());
export { RobotCredentialStoreResourcesSource };
var RobotCredentialStoreResourcesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RobotCredentialStoreResourcesComponent, _super);
    function RobotCredentialStoreResourcesComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RobotCredentialStoreResourcesComponent;
}(ODataGridComponent));
export { RobotCredentialStoreResourcesComponent };
